import { z } from "zod";

export const LiveblocksNotificationSettings = z.object({
    sendCommentNotificationEmails: z.boolean(),
});
export type LiveblocksNotificationSettings = z.infer<typeof LiveblocksNotificationSettings>;

export const UserNotificationSettings = z.object({
    liveblocksNotificationSettings: LiveblocksNotificationSettings,
});

export type UserNotificationSettings = z.infer<typeof UserNotificationSettings>;

export const defaultNotificationSettings: UserNotificationSettings = {
    liveblocksNotificationSettings: {
        sendCommentNotificationEmails: true,
    }
} as const;
